import React from 'react';

import { useManBackgroundImage } from '../../hooks/useManBackgroundImage';
import OneNightStandBase from '../OneNightStand/OneNightStandBase';

const OneNightStandManVariant: React.FC = () => {
  const backgroundImage = useManBackgroundImage();

  return <OneNightStandBase backgroundImage={backgroundImage} />;
};

export default OneNightStandManVariant;
